var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppNavigationItem",
    {
      attrs: {
        title: _vm.$t("calendar", "Share link"),
        "menu-open": _vm.menuOpen
      },
      on: {
        "update:menuOpen": function($event) {
          _vm.menuOpen = $event
        },
        "update:menu-open": function($event) {
          _vm.menuOpen = $event
        }
      }
    },
    [
      _c("template", { slot: "icon" }, [
        _c("div", {
          staticClass: "avatar",
          class: {
            published: _vm.isPublished,
            "icon-public": !_vm.isPublished,
            "icon-public-white": _vm.isPublished
          }
        })
      ]),
      _vm._v(" "),
      !_vm.isPublished
        ? _c(
            "template",
            { slot: "actions" },
            [
              !_vm.publishingCalendar
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-add" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.publishCalendar($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Publish calendar")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.publishingCalendar
                ? _c(
                    "ActionButton",
                    { attrs: { icon: "icon-loading-small", disabled: true } },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Publishing calendar")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPublished
        ? _c(
            "template",
            { slot: "counter" },
            [
              _c(
                "Actions",
                [
                  _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-clippy" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.copyPublicLink($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Copy public link")) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPublished
        ? _c(
            "template",
            { slot: "actions" },
            [
              _vm.showEMailLabel
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-mail" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.openEMailLinkInput($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "calendar",
                              "Send link to calendar via email"
                            )
                          ) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showEMailInput
                ? _c(
                    "ActionInput",
                    {
                      attrs: { icon: "icon-mail" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.sendLinkViaEMail($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Enter one address")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showEMailSending
                ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Sending email …")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopySubscriptionLinkLabel
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-calendar-dark" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.copySubscriptionLink($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Copy subscription link")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopySubscriptionLinkSpinner
                ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Copying link …")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopySubscriptionLinkSuccess
                ? _c("ActionText", { attrs: { icon: "icon-calendar-dark" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Copied link")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopySubscriptionLinkError
                ? _c("ActionText", { attrs: { icon: "icon-calendar-dark" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Could not copy link")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopyEmbedCodeLinkLabel
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-embed" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.copyEmbedCode($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Copy embedding code")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopyEmbedCodeLinkSpinner
                ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Copying code …")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopyEmbedCodeLinkSuccess
                ? _c("ActionText", { attrs: { icon: "icon-embed" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Copied code")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopyEmbedCodeLinkError
                ? _c("ActionText", { attrs: { icon: "icon-embed" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Could not copy code")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.unpublishingCalendar
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-delete" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.unpublishCalendar($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Delete share link")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.unpublishingCalendar
                ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Deleting share link …")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }